import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ACCESS_NHS, ACCESS_RESEARCH, ACCESS_EMPLOYER } from '../constants';
import './style.scss';

const OPTIONS = [
  { value: 'nhs', label: ACCESS_NHS },
  { value: 'email-research', label: ACCESS_RESEARCH },
  { value: 'email-employer', label: ACCESS_EMPLOYER },
];

const AccessSelectorPage = ({ onNHSSelected, onEmailSelected }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleContinue = () => {
    if (selectedOption === 'nhs') {
      onNHSSelected();
    } else {
      onEmailSelected();
    }
  };

  return (
    <div className="sl-access-selector">
      <h1 className="sl-access-selector__title">How do you access Sleepio?</h1>
      <div className="sl-access-selector__options">
        {OPTIONS.map(({ value, label }) => (
          <div
            key={value}
            className={`sl-access-selector__option${
              selectedOption === value
                ? ' sl-access-selector__option--selected'
                : ''
            }`}
            onClick={() => setSelectedOption(value)}
            data-testid={`access-option-${value}`}
          >
            <input
              type="checkbox"
              className="sl-access-selector__checkbox"
              id={`access-option-${value}`}
              checked={selectedOption === value}
              onChange={() => setSelectedOption(value)}
              tabIndex={-1}
            />
            <span
              className="sl-access-selector__check-icon"
              aria-hidden="true"
            />
            <span className="sl-access-selector__option-text">{label}</span>
          </div>
        ))}
      </div>
      <div className="sl-new-login-button-wrapper">
        <button
          type="button"
          className="sl-new-login-button sl-access-selector__continue"
          disabled={!selectedOption}
          onClick={handleContinue}
          data-testid="access-selector-continue"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

AccessSelectorPage.propTypes = {
  onNHSSelected: PropTypes.func.isRequired,
  onEmailSelected: PropTypes.func.isRequired,
};

export default AccessSelectorPage;
